module.exports = __webpack_public_path__ + "img/button__Previous.42cef01f.svg";